export default __webpack_public_path__ + "images/5d84f28fe0755814d269077b6b46ba75-2_4K_1920x544.webp";